import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { useIntl } from "gatsby-plugin-intl"

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => {
  const intl = useIntl()

  const data = useStaticQuery(graphql`
    query {
      picture1: file(relativePath: { eq: "index-picture1.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      picture2: file(relativePath: { eq: "index-picture2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      picture3: file(relativePath: { eq: "index-picture3.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      picture4: file(relativePath: { eq: "index-picture4.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Layout className="f-index">
      <SEO title="Home" />
      <div className="f-index__cover">
        <h2>{intl.formatMessage({ id: "INDEX.TITLE" })}</h2>
        <p>{intl.formatMessage({ id: "INDEX.SUBTITLE" })}</p>
      </div>
      <div className="f-index__quality">
        <h2>{intl.formatMessage({ id: "INDEX.TITLE_QUALITY" })}</h2>
        <p style={{textAlign: 'center'}}>{intl.formatMessage({ id: "INDEX.DESCRIPTION_QUALITY" })}</p>
      </div>
      <div className="f-index__img">
        <div className="f-index__img__library">
          <h2>{intl.formatMessage({ id: "INDEX.TITLE_LIBRARY" })}</h2>
          <p>{intl.formatMessage({ id: "INDEX.TEXT_LIBRARY" })}</p>
          <Link to="contact" className="f-button">
            {intl.formatMessage({ id: "INDEX.BUTTON_LIBRARY" })}
          </Link>
        </div>
      </div>
      <div className="f-index__presentation">
        <div className="grid-pictures">
          <Img fluid={data.picture1.childImageSharp.fluid} />
          <Img fluid={data.picture2.childImageSharp.fluid} />
          <Img fluid={data.picture3.childImageSharp.fluid} />
          <Img fluid={data.picture4.childImageSharp.fluid} />
        </div>
        <div className="description">
          <div>
            <p>{intl.formatMessage({ id: "INDEX.TEXT_DESCRIPTION_1" })}</p>
            <p>{intl.formatMessage({ id: "INDEX.TEXT_DESCRIPTION_2" })}</p>
          </div>
          <div>
            <p>{intl.formatMessage({ id: "INDEX.TEXT_DESCRIPTION_3" })}</p>
            <p>{intl.formatMessage({ id: "INDEX.TEXT_DESCRIPTION_4" })}</p>
          </div>
        </div>
        <Link to="contact" className="f-button">
          {intl.formatMessage({ id: "INDEX.BUTTON_CONTACT" })}
        </Link>
      </div>

      <div className="f-index__img">
        <div className="f-index__img__bridge">
          <h2>{intl.formatMessage({ id: "INDEX.TITLE_BRIDGE" })}</h2>
        </div>
      </div>

      <div className="f-index__info">
        <div className="description">
          <div>
            <h3>{intl.formatMessage({ id: "INDEX.TITLE_INFO_1" })}</h3>
            <p>{intl.formatMessage({ id: "INDEX.TEXT_INFO_1.0" })}</p>
            <p>{intl.formatMessage({ id: "INDEX.TEXT_INFO_1.1" })}</p>
          </div>
          <div>
            <h3>{intl.formatMessage({ id: "INDEX.TITLE_INFO_2" })}</h3>
            <p>{intl.formatMessage({ id: "INDEX.TEXT_INFO_2.0" })}</p>
            <p>{intl.formatMessage({ id: "INDEX.TEXT_INFO_2.1" })}</p>
          </div>
          <div>
            <h3>{intl.formatMessage({ id: "INDEX.TITLE_INFO_3" })}</h3>
            <p>{intl.formatMessage({ id: "INDEX.TEXT_INFO_3" })}</p>
          </div>
        </div>
        <div className="grid-pictures">
          <div className="grid-pictures__item"></div>
          <div className="grid-pictures__item"></div>
          <div className="grid-pictures__item"></div>
          <div className="grid-pictures__item"></div>
        </div>
        <Link to="contact" className="f-button">
          {intl.formatMessage({ id: "INDEX.BUTTON_THANKS" })}
        </Link>
      </div>
    </Layout>
  )
}

export default IndexPage
